import { Outlet } from "react-router-dom";
import { Image } from "@nextui-org/react";
import Logo from "@/assets/logo.svg";

export default function BindWrapper() {
  return (
    <div className="min-h-screen flex flex-col md:flex-row justify-center items-center ">
      <div className=" md:flex-auto flex justify-center items-center px-20">
        <div className="hidden md:block">
          <Image isZoomed width={240} src={Logo} />
          <h1 className="text-4xl font-bold text-center">P i n n a c l e</h1>
        </div>
        <h1 className="text-4xl font-bold text-center md:hidden py-20">
          Pinnacle
        </h1>
      </div>
      <div className=" flex-auto md:flex-auto flex justify-center md:px-4">
        <Outlet />
      </div>
    </div>
  );
}
